var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalLaundryServiceBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 200",
    style: {
      fill: "none"
    },
    d: "M0 0h34v34H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1065",
    d: "M11.99 22.343a4.728 4.728 0 0 0 6.687-6.687zM23.833 2.014 6.833 2A2.824 2.824 0 0 0 4 4.833V27.5a2.824 2.824 0 0 0 2.833 2.833h17a2.824 2.824 0 0 0 2.834-2.833V4.833a2.812 2.812 0 0 0-2.834-2.819zM13.917 6.25A1.417 1.417 0 1 1 12.5 7.667a1.421 1.421 0 0 1 1.417-1.417zm-4.25 0A1.417 1.417 0 1 1 8.25 7.667 1.421 1.421 0 0 1 9.667 6.25zm5.667 19.833A7.083 7.083 0 1 1 22.417 19a7.086 7.086 0 0 1-7.084 7.083z",
    transform: "translate(1.667 .833)",
    style: {
      fill: "#b0b0b0"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalLaundryServiceBlack24Dp);
export default __webpack_public_path__ + "static/media/local_laundry_service_black_24dp.f36e7f9008771be701593fca5d3c9015.svg";
export { ForwardRef as ReactComponent };